(function() {
	'use strict';

	angular.module('fuel').directive('fuelPriceSearch',
			fuelPriceSearch).directive('focusOn', function($timeout) {
		return {
			restrict : 'A',
			link : function(vm, $element, $attr) {
				vm.$watch($attr.focusOn, function(_focusVal) {
					$timeout(function() {
						_focusVal ? $element[0].focus() : $element[0].blur();
					});
				});
			}
		}
	});

	function fuelPriceSearch(MessageService, $stateParams) {
		return {
			restrict : 'EA',
			scope : {
				openSearchPanel : '&',
				onSearchSubmit : '&',
        onNewClick : '&',
				airports : '=',
				showSearchArea : '='
			},
			templateUrl : 'fuel/directives/fuel-price-search-derective.tpl.html',
			replace : false,
			controllerAs : 'searchPanel',
			bindToController : true,

			controller : [
					'$scope',
					function($scope) {
						var vm = this;
						vm.showError = false;

						vm.displaySearchArea = function() {
							vm.showSearchArea = !vm.showSearchArea;
							vm.openSearchPanel();
						};

						vm.onSearchClick = function() {
							if (!!vm.selectedAirport) {
								vm.onSearchSubmit({
									'searchParam' : vm.selectedAirport
								});
							} else {
								vm.showError = true;
							}
						};

						vm.noNewClick = function () {
              vm.onNewClick();
            }

					} ],
			link : function(scope, element, attrs) {

			}
		};
	}
}());
